import React, { useEffect, useState } from "react";
import { postDQListButtonPreoperatorio, postInsertPreoperatorio } from "../../../services/PaginaRuta";
import ModalListaDeSeleccionDeDiagnosticosPreOperatorio from "./ModalListaDeSeleccionDeDiagnosticosPreOperatorio";
import TablaDiagnosticosDescripcionQxPreoperatorio from "./TablaDiagnosticosDescripcionQxPreoperatorio";

const ModalDiagnosticosDescripcionQxPreoperatorio = ({  setmodalOnDiagnosticoDescripcionPreoperatorio,procir,codigoMedico}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [listaSeleccionDiagnostico, setlistaSeleccionDiagnostico]=useState(false)
  const [passDataGuardarPreoperatorio, setpassDataGuardarPreoperatorio]=useState({
    CodDxPrPo: '',
    DMNomb: ''
  })
  const [dataPreoperatorio, setdataPreoperatorio]=useState([])
  const [observacionesPreoperatorio, setobservacionesPreoperatorio]=useState({observacionPO:''})
  const [actualizarTable, setactualizarTable]=useState([])
  const handleOnclickSeleccionDiagnostico=()=>{
    setlistaSeleccionDiagnostico(true)
  }
  const handleCancelarClick = () => {
    setmodalOnDiagnosticoDescripcionPreoperatorio(false);
  };
  const passDataPreoperatorio=(data)=>{
    setpassDataGuardarPreoperatorio(data)
  }
  useEffect(()=>{
    const listPreoperatorio={
      CodMcdpto: usuarioInfo.Sede,
      CodTipDx: 'P',
      CodEmpCod: usuarioInfo.Empresa,
      
      CodMed: codigoMedico,
      CodCir: procir
    }
    //console.log(listPreoperatorio,'list ilis')
    postDQListButtonPreoperatorio(listPreoperatorio).then((res)=>{
      console.log(res.data,'data list')
      setdataPreoperatorio(res.data)
    })
    setobservacionesPreoperatorio({observacionPO:''})
  },[actualizarTable])

  const handleOnclickGuardarPreoperatorio =()=>{
    const guardarPreoperatorio={
      CodTipDx: "P",
      CodDxPrPo: passDataGuardarPreoperatorio.CodDxPrPo,
      CodCir: procir,
      CodMed: codigoMedico,
      CodMcdpto: usuarioInfo.Sede,
      CodEmpCod: usuarioInfo.Empresa,
      CodObsDx: observacionesPreoperatorio.observacionPO
    }
    if(passDataGuardarPreoperatorio.CodDxPrPo !== ''){
      //console.log(guardarPreoperatorio,'guardarPreoperatorio')
      postInsertPreoperatorio(guardarPreoperatorio).then((res)=>{
        setpassDataGuardarPreoperatorio({
          CodDxPrPo: '',
          DMNomb: ''
        })
        setobservacionesPreoperatorio({observacionPO:''})
        setactualizarTable(guardarPreoperatorio)
      })
     
    }
    
  }

  const handleOnchangeObservaciones = (e)=>{
    //console.log(e.target.value)
    setobservacionesPreoperatorio({observacionPO:e.target.value})
  }
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)] max-w-7xl mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Diagnóstico de descripción Qx 
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="px-8 pt-3">
              <h5
                className="text-lg font-medium leading-normal text-gray-800"
                id="exampleModalScrollableLabel"
              >
                DX PREOPERATORIO
              </h5>
            </div>
            <div className="flex-auto overflow-y-auto relative p-2">
              
              <div className="flex py-2 text-left">
                <div className="w-1/5  px-4 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Codigo Diagnóstico
                  </label>
                  <input
                    defaultValue={passDataGuardarPreoperatorio.CodDxPrPo}
                    disabled={true}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-2/5  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  <input
                    defaultValue={passDataGuardarPreoperatorio.DMNomb}
                    disabled={true}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                {/* <form> */}
                  <div className="w-2/5  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Observación
                    </label>
                    <input
                      //name="observaciones"
                      value={observacionesPreoperatorio.observacionPO}
                      onChange={handleOnchangeObservaciones}
                      autoComplete="off"
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/5  px-1 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
                    <button
                      onClick={handleOnclickGuardarPreoperatorio}
                      type="button"
                      className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Guardar
                    </button>
                  </div>
                {/* </form> */}
              </div>
              
              <div className="w-1/5  px-1 ">
                <label className="form-label block mb-2 text-gray-900 font-medium pt-3"></label>
                <button
                  type="button"
                  onClick={handleOnclickSeleccionDiagnostico}
                  className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Lista de Selección Diagnóstico
                </button>
              </div>
              
              <div className="flex flex-col">
                <div className="overflow-x-auto ">
                  <div className="py-2 inline-block min-w-full ">
                    <div className="overflow-hidden">
                      <table className="min-w-full text-center">
                        <thead className="border-b bg-gray-200">
                          <tr>
                            
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-2"
                            >
                              Código Dx
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-2"
                            >
                              Descripción
                            </th>
                            <th
                              scope="col"
                              className="text-sm font-medium text-gray-900 px-6 py-2"
                            >
                              Observación
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataPreoperatorio.map((item,index)=>(
                            <TablaDiagnosticosDescripcionQxPreoperatorio key={index} item={item}/>
                          ))}
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              {/* <button type="button"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button> */}
            </div>
          </div>
        </div>
      </div>
      {listaSeleccionDiagnostico? <ModalListaDeSeleccionDeDiagnosticosPreOperatorio setlistaSeleccionDiagnostico={setlistaSeleccionDiagnostico} passDataPreoperatorio={passDataPreoperatorio}/>:null}
    </>
  );
};

export default ModalDiagnosticosDescripcionQxPreoperatorio;
